import { memo, useMemo } from 'react';

// material-ui
import { Typography } from '@mui/material';

// project imports
import NavGroup from './NavGroup';
import menuItem from 'menu-items';
import { NavItemType } from 'types';
import { useSelector } from 'store';
import { SkeletonMenu } from 'ui-component/cards/Skeleton/SkeletonMenu';
import { AvailableMenuType } from 'types/components/shared';

// ==============================|| SIDEBAR MENU LIST ||============================== //

const MenuList = () => {
    const { loading, menuDetails } = useSelector((state) => state.auth);

    const dataMenu = menuItem || [];

    const listaMenu: NavItemType[] = useMemo(() => {
        return dataMenu.items.filter((item: NavItemType) => menuDetails.find((key: AvailableMenuType) => item.id === referencia[key.type]));
    }, [dataMenu.items, menuDetails]);

    const filteredMenu = useMemo(() => {
        return listaMenu.map((menu: any) => {
            const matchingChildren = menu.children.filter((child: NavItemType) => {
                const tipoReferencia = childrenReferencia[child.id!];
                return menuDetails.some((dataItem: AvailableMenuType) =>
                    dataItem.children.some((subChild: AvailableMenuType) => subChild.type === tipoReferencia)
                );
            });

            return {
                ...menu,
                children: matchingChildren
            };
        });
    }, [listaMenu, menuDetails]);

    const navItems = useMemo(() => {
        return filteredMenu.map((item: NavItemType) => {
            switch (item.type) {
                case 'group':
                    return <NavGroup key={item.id} item={item} />;
                default:
                    return (
                        <Typography key={item.id} variant="h6" color="error" align="center">
                            Menu Items Error
                        </Typography>
                    );
            }
        });
    }, [filteredMenu]);

    return (
        <>
            {(loading || !navItems.length) && <SkeletonMenu />}
            {navItems}
        </>
    );
};

export default memo(MenuList);

const referencia: { [key: string]: string } = {
    Dashboard: 'health-content',
    Catalogo: 'catalogue-roadmap',
    Reportes: 'reports-roadmap',
    Seguridad: 'security-group'
};

const childrenReferencia: { [key: string]: string } = {
    'overall-score': 'Detalle',
    products: 'Productos',
    brands: 'Marcas',
    supplier: 'Proveedores',
    facets: 'Facets',
    categories: 'Categorías',
    massive_load: 'Actualización Masiva',
    change_log: 'Bitácora de Cambios',
    users: 'Usuarios',
    profiles: 'Perfiles'
};
